import { AppVersionTag } from '@components/AppVersionTag';
import { EnvironmentRibbon } from '@components/EnvironmentRibbon';
import { EnvironmentRibbonDemo } from '@components/EnvironmentRibbon/variations/EnvironmentRibbonDemo';
import { EnvironmentRibbonDev } from '@components/EnvironmentRibbon/variations/EnvironmentRibbonDev';
import { formatAppVersion } from '@helpers/formatAppVersion';
import { getEnvironmentFromHostname } from '@helpers/getEnvironmentFromHostname';
import { applyTheme, getStoredTheme, parseTheme } from '@helpers/theme';
import { InitProvider } from '@providers/InitProvider';

import { Main } from '@wrappers/Main';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';

export function App() {
  const environment = getEnvironmentFromHostname(window.location.hostname);
  const version = formatAppVersion(import.meta.env.VITE_APP_VERSION, import.meta.env.VITE_COMMIT_SHA);

  useEffect(() => {
    applyTheme(getStoredTheme());

    const onThemeStorageUpdate = (event: StorageEvent) => {
      if (event.key === 'theme') {
        applyTheme(parseTheme(event.newValue));
      }
    };

    window.addEventListener('storage', onThemeStorageUpdate);

    return () => {
      window.removeEventListener('storage', onThemeStorageUpdate);
    };
  }, []);

  useEffect(() => {
    const isLocationSaved = window.localStorage.getItem('redirectUrl');

    if (!isLocationSaved) {
      window.localStorage.setItem('redirectUrl', window.location.href);
    }
  }, []);

  return (
    <HelmetProvider>
      <AppVersionTag version={version} />
      {environment === 'staging' ? <EnvironmentRibbon label="STAGING" className="env-ribbon--app" /> : null}
      {environment === 'demo' ? <EnvironmentRibbonDemo label="DEMO" className="env-ribbon--app" /> : null}
      {environment === 'dev' ? <EnvironmentRibbonDev label="DEV" className="env-ribbon--app" /> : null}
      <InitProvider>
        <Main />
      </InitProvider>
    </HelmetProvider>
  );
}
